import { render, staticRenderFns } from "./SubscriptionLoop.vue?vue&type=template&id=0970e4c3"
import script from "./SubscriptionLoop.vue?vue&type=script&lang=js"
export * from "./SubscriptionLoop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports